export default {"src":"/_next/static/media/SuccessGreenLogo.7ec32e9c.gif","height":500,"width":500};